// First-visit disclaimer + analytics consent prompt. Stores ack in localStorage
// so returning users aren't pestered.

import { isConsentPrompted, markConsentPrompted, setTier1, setTier2 } from './analytics';

const KEY = 'mystack:disclaimer-ack:v1';

export function maybeShowDisclaimer() {
  if (localStorage.getItem(KEY)) {
    maybeShowConsentPrompt();
    return;
  }
  const back = document.createElement('div');
  back.className = 'modal-back';
  back.innerHTML = `
    <div class="modal-box">
      <h2>Welcome to MyStack 👋</h2>
      <p><strong>This is a personal tracking and reference tool — not medical advice.</strong></p>
      <p>You'll find paraphrased summaries of public research with citations to the original sources. Anything you read here is general education, not a recommendation for your specific health, medications, or condition. Talk to a clinician before changing what you take.</p>
      <p>This website does not sell ANY products, or endorse any product or group of products based on any information presented herein. All informational product links are pointing to pre-existing public listings of legal products offered by independent sellers on the amazon.com platform. All cited information discussing any product or compound seen on this website is paraphrased from studies cited as sources for all paraphrased information.</p>
      <p style="font-size:12px;color:var(--dim);">Your tracking data stays yours and isn't sold.</p>
      <p class="small">By continuing you acknowledge you understand this is not medical advice and that the platform may earn affiliate revenue from outbound vendor links.</p>
      <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;">
        <button id="disclaimer-ack" class="btn btn-primary">I understand — let me in</button>
      </div>
    </div>
  `;
  document.body.appendChild(back);
  document.getElementById('disclaimer-ack')?.addEventListener('click', () => {
    localStorage.setItem(KEY, String(Date.now()));
    back.remove();
    maybeShowConsentPrompt();
  });
}

function maybeShowConsentPrompt() {
  if (isConsentPrompted()) return;
  const back = document.createElement('div');
  back.className = 'modal-back';
  back.innerHTML = `
    <div class="modal-box">
      <h2>Help improve MyStack?</h2>
      <label style="display:flex;align-items:flex-start;gap:10px;padding:10px;background:var(--bg-3);border-radius:6px;cursor:pointer;margin-top:10px;">
        <input type="checkbox" id="ct1" />
        <span>
          <strong>Anonymous usage data</strong><br/>
          <span class="small">Tap-level analytics so we know which compounds and features matter. No identity attached.</span>
        </span>
      </label>
      <label style="display:flex;align-items:flex-start;gap:10px;padding:10px;background:var(--bg-3);border-radius:6px;cursor:pointer;margin-top:8px;">
        <input type="checkbox" id="ct2" />
        <span>
          <strong>Anonymized research data</strong><br/>
          <span class="small">Your doses, biometrics, wellbeing scores — stripped of name, email, and account id. Unlocks cohort-driven features as they roll out.</span>
        </span>
      </label>
      <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:14px;">
        <button id="ct-no" class="btn">No thanks</button>
        <button id="ct-save" class="btn btn-primary">Save</button>
      </div>
    </div>
  `;
  document.body.appendChild(back);
  document.getElementById('ct-no')?.addEventListener('click', () => {
    setTier1(false);
    setTier2(false);
    markConsentPrompted();
    back.remove();
  });
  document.getElementById('ct-save')?.addEventListener('click', () => {
    setTier1((document.getElementById('ct1') as HTMLInputElement).checked);
    setTier2((document.getElementById('ct2') as HTMLInputElement).checked);
    markConsentPrompted();
    back.remove();
  });
}
